import React from 'react';
import { Download, Tag, ArrowRight } from 'lucide-react';

const PEPTIQ_URL = "https://peptiq.io/go/ninja";

export const PeptiqInlineCTA = () => (
  <div
    className="my-10 bg-gradient-to-br from-zinc-900 via-zinc-900/80 to-zinc-900/50 border border-[#00F0FF]/20 overflow-hidden"
    data-testid="peptiq-inline-cta"
  >
    <div className="h-0.5 bg-gradient-to-r from-[#E63946] via-[#00F0FF] to-[#E63946]" />
    <div className="p-6 md:p-8">
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-5">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-2">
            <span className="px-2 py-0.5 bg-[#00F0FF]/10 border border-[#00F0FF]/20 text-[#00F0FF] text-[10px] uppercase tracking-widest font-bold">
              App
            </span>
            <span className="text-zinc-500 text-xs">Peptide Protocol Tracker</span>
          </div>
          <h4
            className="text-white text-lg mb-1.5"
            style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.02em' }}
          >
            Track Your Protocol with PeptIQ
          </h4>
          <p className="text-zinc-400 text-sm leading-relaxed mb-3">
            AI-powered dosing, smart reminders, and progress logging — all in one app. Never miss a dose.
          </p>
          <div className="inline-flex items-center gap-1.5 px-2.5 py-1.5 bg-black/40 border border-[#E63946]/20 text-xs">
            <Tag className="w-3 h-3 text-[#E63946] flex-shrink-0" />
            <span className="text-zinc-300">
              Code <span className="text-[#E63946] font-bold">NINJA</span> — <span className="text-white font-semibold">20% off annual</span> ($80/yr)
            </span>
          </div>
        </div>
        <a
          href={PEPTIQ_URL}
          target="_blank"
          rel="sponsored noopener noreferrer"
          className="inline-flex items-center gap-2 px-6 py-3 bg-[#E63946] text-white font-bold text-sm uppercase tracking-wider no-underline hover:bg-[#E63946]/90 transition-colors whitespace-nowrap flex-shrink-0"
          style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.05em' }}
          data-testid="peptiq-inline-cta-download"
        >
          <Download className="w-4 h-4" />
          Download PeptIQ
          <ArrowRight className="w-3.5 h-3.5" />
        </a>
      </div>
    </div>
  </div>
);

/**
 * Splits article HTML content at approximately 40% (after a heading tag near that point)
 * Returns [firstHalf, secondHalf]. If no good split point, returns [content, null].
 */
export function splitContentForCTA(htmlContent) {
  if (!htmlContent || htmlContent.length < 800) return [htmlContent, null];

  const targetPos = Math.floor(htmlContent.length * 0.4);

  // Find all h2/h3 tag positions
  const headingRegex = /<h[23][^>]*>/gi;
  let match;
  const positions = [];
  while ((match = headingRegex.exec(htmlContent)) !== null) {
    positions.push(match.index);
  }

  if (positions.length < 2) return [htmlContent, null];

  // Find the heading closest to the 40% mark (but at least the 2nd heading)
  let bestPos = positions[1]; // default to 2nd heading
  for (let i = 1; i < positions.length; i++) {
    if (positions[i] >= targetPos) {
      bestPos = positions[i];
      break;
    }
    bestPos = positions[i];
  }

  return [htmlContent.slice(0, bestPos), htmlContent.slice(bestPos)];
}

export default PeptiqInlineCTA;
